import React, { useState, useEffect } from "react";
import { useGlobalContext } from "../../utils/globalContext";

const TextSliderVertical = ({ content = [] }) => {
  const [index, setIndex] = useState(0);
  const [partial, setPartial] = useState(content);
  const [translate, setTranslate] = useState(false);
  const { Trans } = useGlobalContext();

  const fadeText = () => {
    setTranslate(true);
    return new Promise(resolve => {
      setTimeout(() => resolve(), 2000);
    });
  };

  useEffect(() => {
    if (content.length > 1) setPartial([content[index], content[(index + 1) % content.length]]);
  }, [index, content]);

  useEffect(() => {
    let isMounted = true;
    const interval = setInterval(() => {
      fadeText().then(() => {
        if (isMounted) {
          setIndex((index + 1) % content.length);
          setTranslate(false);
        }
      });
    }, 4000);
    return () => {
      isMounted = false;
      clearInterval(interval);
    };
    // eslint-disable-next-line
  }, [content.length]);

  return (
    <div id="textSliderVertical">
      {partial.map((text, i) => {
        return (
          <h1
            key={i}
            className={`slidingTitle ${i === 0 && translate ? "fadeOut" : ""}  ${
              i === 1 && translate ? "fadeIn" : ""
            } ${i === 1 && !translate ? "transparent" : ""}`}>
            <Trans>{text.content}</Trans>
          </h1>
        );
      })}
    </div>
  );
};

export default TextSliderVertical;
